<script setup async>
import AvatarImageLoader from "~/components/loaders/AvatarImageLoader.vue";
const props = defineProps({
  showHeader : {
    type: Boolean,
    default: true
  }
})
const sports = await useAllSports();

// Link a sport chip to its landing page only when the API gives a frontendLink.
const linkFor = (sport) => {
  const f = sport?.frontendLink;
  if (!f) return null;
  return f.startsWith('/') || f.startsWith('http') ? f : `/sports/${f}`;
};
</script>

<template>
  <div>
    <div v-if="showHeader" class="text-center mb-2">
      <div class="tl-label text-primary">Any sport</div>
      <h2 class="sports-heading">A sport for every player</h2>
    </div>
    <div class="sports-marquee">
      <NuxtMarquee
          :speed="25"
          :loop="0"
          :auto-fill="true"
      >
        <component
            :is="linkFor(sport) ? 'router-link' : 'div'"
            :to="linkFor(sport) || undefined"
            class="sport-chip"
            :class="{ 'sport-chip--link': linkFor(sport) }"
            v-for="sport in sports"
            :key="sport.id"
        >
          <avatar-image-loader :image-file-name="sport.imageFileName" class="mr-3" size="32"/>
          <div class="sport-name">{{ sportDisplayName(sport) }}</div>
        </component>
      </NuxtMarquee>
    </div>
  </div>
</template>

<style scoped lang="scss">
.sports-heading {
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin-top: 6px;
  margin-bottom: 10px;
}

.sports-marquee {
  overflow: hidden;
}

.sport-chip {
  display: inline-flex;
  align-items: center;
  background: rgb(var(--v-theme-surface));
  border: 1px solid rgb(var(--v-theme-borderLight));
  border-radius: 999px;
  padding: 8px 18px 8px 10px;
  margin: 8px;
}

.sport-name {
  font-size: 13px;
  font-weight: 600;
  color: rgb(var(--v-theme-charcoal));
  white-space: nowrap;
}

/* clickable chips (sport has a frontendLink) */
.sport-chip--link {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;

  &:hover {
    border-color: rgb(var(--v-theme-primary));
    box-shadow: 0 8px 18px -12px rgba(26, 26, 26, 0.4);
    transform: translateY(-1px);
  }
}
</style>
